
    var riot = require('riot')
    //src: starling/src/tags/bulk-actions-menu.html
riot.tag2('bulk-actions-menu',
  '<div if="{showToolbar()}" onmouseenter="{handleMouseEnter}" onmouseleave="{handleMouseLeave}" ref="menuList" class="bulk-actions-menu_list"> <menu-button-add-image if="{isCardTarget()}" canvas="{canvas}"></menu-button-add-image> <menu-button-add-summary if="{isCardTarget()}" canvas="{canvas}"></menu-button-add-summary> <menu-button-style-card if="{showCardStyleOptions()}" canvas="{canvas}"></menu-button-style-card> <menu-button-relationship-style if="{showLineOptions()}"></menu-button-relationship-style> <div if="{isCardTarget()}" class="bulk-actions-menu_divider"></div> <menu-button-add-part if="{isCardTarget()}" canvas="{canvas}"></menu-button-add-part> <menu-button-create-relationship if="{isCardTarget() || showAddRelationshipOption()}" canvas="{canvas}"></menu-button-create-relationship> <menu-button-perspectives if="{showPerspectiveOptions()}" canvas="{canvas}"></menu-button-perspectives> <menu-button-attribute-editor if="{canvas.isFeatureEnabled(\'attributes\') && isCardTarget()}"></menu-button-attribute-editor> <div if="{isCardTarget()}" class="bulk-actions-menu_divider"></div> <menu-button-alignment if="{showAlignmentOptions()}" canvas="{canvas}"></menu-button-alignment> <menu-button-group if="{showGroupSelection()}" canvas="{canvas}"></menu-button-group> <menu-button-link-curvature if="{showLineOptions()}" canvas="{canvas}"></menu-button-link-curvature> <menu-button-create-relationship-card if="{showAddRelationshipCardOption()}"></menu-button-create-relationship-card> <menu-button-link-direction if="{showRelationshipArrowOptions()}"></menu-button-link-direction> <menu-button-layout if="{showPartOptions()}" canvas="{canvas}"></menu-button-layout> <menu-button-pop-parts if="{showPartOptions() && (this.showPopOut() || this.showPopIn())}" inorout="{this.showPopIn() ? \'in\' : \'out\'}" canvas="{canvas}"></menu-button-pop-parts> <menu-button-detach-parts if="{showDetachPart()}"></menu-button-detach-parts> <menu-button-detach-from-relationship if="{showDetachRelationshipCard()}"></menu-button-detach-from-relationship> <menu-button-add-comment if="{showCommentOption()}" canvas="{canvas}"></menu-button-add-comment> <menu-button-delete if="{showDelete()}" canvas="{canvas}"></menu-button-delete> <menu-button-edit-region-title if="{showEditRegionTitle()}" canvas="{canvas}"></menu-button-edit-region-title> <menu-button-edit-region-color if="{showRegionOptions()}" canvas="{canvas}"></menu-button-edit-region-color> <menu-button-edit-region-shape if="{showRegionOptions()}" canvas="{canvas}"></menu-button-edit-region-shape> <menu-button-select-all-in-region if="{showRegionOptions()}" canvas="{canvas}"></menu-button-select-all-in-region> <menu-button-delete-region if="{showRegionOptions()}" canvas="{canvas}"></menu-button-delete-region> <div if="{!showPersistentElements()}" class="bulk-actions-menu_divider"></div> <button if="{!showPersistentElements()}" ref="toggleMoreOption" class="unstyled_button bulk-actions-menu-item" onclick="{toggleMore}" data-tip="More"> <svg class="floating-menu_button_icon bulk-actions-menu-item_icon"> <use xlink:href="#more-vert-icon"></use> </svg> </button> </div>',
  '',
  'class="bulk-actions-menu bulk-actions-menu--{getToolbarTargetClass()}"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util.js');

var _waypointsUi = require('lib/waypoints-ui');

var _waypointsUi2 = _interopRequireDefault(_waypointsUi);

var _nodesUi = require('lib/nodes-ui');

var _toolbarUi = require('lib/toolbar-ui');

var _menuUi = require('lib/menu-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _regionUi = require('lib/region-ui');

var _drawingUi = require('lib/drawing-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = opts.canvas;
this.canvas = canvas;

this.operation = canvas.operation;
canvas.bulkActionsMenuTag = this;
this.menuName = 'toolbar';
this.toolsReset = false;

this.popOutMessages = [];

this.on('mount', _eventTracking2.default.listen(this.root));

this.on('updated', function () {
  canvas.hideSubmenus();
  _eventTracking2.default.listen(_this.root);
  _this.toolsReset = false;
});

this.showPersistentElements = function () {
  return canvas.selectedElements.length < 1;
};

this.toggle = function () {
  if (_this.refs.menuList.classList.contains('hidden')) {} else {
    canvas.hidePopups();
  }
  _this.show();
};

this.shown = function () {};

this.show = function () {
  //      this.refs.menuList.classList.remove('hidden');
};

this.hide = function () {
  //      this.refs.menuList.classList.add('hidden');
  //      this.refs.menuList.classList.remove('child-nodes-menu');
  if (_this.getRelationshipStylePickerTag()) _this.getRelationshipStylePickerTag().hideSubMenu();
  if (_this.getCardStylePickerTag()) _this.getCardStylePickerTag().hideSubMenu();
  if (_this.getDrawingStylePickerTag()) _this.getDrawingStylePickerTag().hideSubMenu();

  canvas.exportMenu.hide();
  canvas.nodePerspectivesPanelTag.clearInput();
  _this.closeMore();
};

this.setViewMoreActive = function () {
  _this.refs.toggleMoreOption.setAttribute('data-tip-hide', 'true');
  _this.setActiveTool(_this.refs.toggleMoreOption);
};

this.getRelationshipStylePickerTag = function () {
  return _this.tags['menu-button-relationship-style'];
};

this.getCardStylePickerTag = function () {
  return _this.tags['menu-button-style-card'];
};

this.getDrawingStylePickerTag = function () {
  return _this.tags['menu-button-drawing-style'];
};

this.getSelectedLinkIds = function () {
  return canvas.getSelectedLinks().map(function (l) {
    return l.id;
  });
};

this.getSelectedNodeIds = function () {
  return canvas.getSelectedNodes().map(function (n) {
    return n.id;
  });
};

this.getSelectedRegionIds = function () {
  return _regionUi.regionUI.getSelectedRegionIdsArray();
};

this.attachChildren = function (i) {
  i.instance.setChildrenDetached(false);
  i.updateChildDetachment(i.id);
  i.updateTopLevelNeighborsLite();
  _this.popOutMessages.push(_this.operation.messages.setChildrenDetached({
    nodeUUID: i.id,
    detached: false,
    x: i.childrenPosition.x,
    y: i.childrenPosition.y
  }));
};

this.detachChildren = function (i) {
  var width = i.instance.width;
  var x = void 0;
  var y = void 0;
  if (!i.childrenPosition || i.childrenPosition.x === undefined || i.childrenPosition.y === undefined) {
    x = Math.min(275, width + 40);
    y = -60;
    i.setChildrenPosition({ x: x, y: y });
  }

  i.instance.setChildrenDetached(true);
  i.updateChildDetachment(i.id);
  i.updateTopLevelNeighborsLite();
  if (i.childNodesTag) {
    i.childNodesTag.updatePosition();
    i.childNodesTag.updateShadow();
    i.childNodesTag.enableDragging();
  }
  _this.popOutMessages.push(_this.operation.messages.setChildrenDetached({
    nodeUUID: i.id,
    detached: true,
    x: x,
    y: y
  }));
};

this.makeWaypointFromSelection = function () {
  var nodes = canvas.getSelectedNodes();
  var toolsSidebarTag = canvas.toolsSidebarTag;

  _waypointsUi2.default.addWaypoint({
    nodeIds: nodes.map(function (n) {
      return n.id;
    }),
    title: nodes[0].title
  });

  if (!toolsSidebarTag.isTabActive('waypoints-tab')) {
    toolsSidebarTag.activateTab({
      tabTagName: 'waypoints-tab',
      push: true
    });
  }

  _this.hide();
};

this.linkToSelection = function () {
  var selectedNodes = canvas.getSelectedNodes();
  if (selectedNodes.length > 0) {
    var commaSeparatedIds = selectedNodes.map(function (n) {
      return n.id;
    }).join(',');
    var url = self.config.site_url + '/maps/' + self.access.publicIdentifier + '/edit/' + self.access.editKey + '?nodeid=' + commaSeparatedIds;
    window.history.pushState({}, "", url);
    (0, _util.copyToClipboard)({ text: url });
    canvas.centerContent({ nodes: selectedNodes });
    canvas.notificationTag.show({ message: "Link copied to clipboard" });
    _this.update();
    canvas.hidePopups();
  }
};

/* submenus */

this.resetTools = function () {
  if (!_this.toolsReset) {
    _this.toolsReset = true;
    _this.clearActiveTools();
    $('bulk-actions-menu [data-tip-hide]').removeAttr('data-tip-hide');
  }
};

this.clearActiveTools = function () {
  $('bulk-actions-menu .bulk-actions-menu-item.active').removeClass('active');
};

this.toggleMore = function (e) {
  e.stopPropagation();
  if (canvas.toolbarViewMoreMenu.isOpen) {
    _this.closeMore();
  } else {
    _this.resetTools();

    canvas.toolbarViewMoreMenu.summon({
      referenceEl: _this.refs.toggleMoreOption
    });
  }
};
this.closeMore = function () {
  if (_this.refs.toggleMoreOption) {
    _this.refs.toggleMoreOption.removeAttribute('data-tip-hide');
    _this.unsetActiveTool(_this.refs.toggleMoreOption);
  }
  canvas.toolbarViewMoreMenu.hide();
};

/* functions for deciding what to show */

this.showRelationshipArrowOptions = function () {
  if (canvas.getSelectedLinks().length) {
    return true;
  }
};

this.showLineOptions = function () {
  if (canvas.getSelectedLinks().length) {
    return true;
  }
  return false;
};

this.showCardStyleOptions = function () {
  if (canvas.getSelectedNodes().length) {
    return true;
  }
  return false;
};

this.showDrawingOptions = function () {
  return !!_drawingUi.drawingUI.getSelectedDrawings().length;
};

this.showCreateCardOption = function () {
  if (canvas.getSelectedLinks().length && canvas.getSelectedNodes().length == 0) return false;
  return true;
};

this.showPerspectiveOptions = function () {
  if (!canvas.isFeatureEnabled('perspectives')) return false;
  if (canvas.getSelectedLinks().length || canvas.getSelectedNodes().length) {
    return true;
  }
  return false;
};

this.showAddRelationshipCardOption = function () {
  return _toolbarUi.tui.showAddRelationshipCardOption();
};

// if two cards are selected, we can create a relationship between them
this.showAddRelationshipOption = function () {
  if (canvas.getSelectedLinks().length) {
    return false;
  }
  if (canvas.getSelectedNodes().length == 2) {
    return true;
  }
  return false;
};

this.showAlignmentOptions = function () {
  //verify that nodes are alignable
  return canvas.nodeAlignmentPanelTag && canvas.nodeAlignmentPanelTag.hasAlignableNodes();
};

this.showPartOptions = function () {
  return _toolbarUi.tui.showPartOptions();
};

this.showPopIn = _menuUi.mui.showPopIn.bind(this);
this.showPopOut = _menuUi.mui.showPopOut.bind(this);

/* if only parts or parents are selected show this in the toolbar; if only some selected cards are parts or parents, we'll show it in View More */
this.showDetachPart = function () {
  if (canvas.getSelectedLinks().length) return false;
  if (canvas.getSelectedNodes().length == 0) return false;
  if (canvas.getSelectedNodes().some(function (n) {
    return n.parentId;
  })) return true;
  return false;
};

this.showDetachRelationshipCard = function () {
  return _toolbarUi.tui.showDetachRelationshipCard();
};

this.showDelete = function () {
  return canvas.getSelectedNodes().length || canvas.getSelectedLinks().length || _drawingUi.drawingUI.getSelectedDrawings().length;
};

this.showGroupSelection = function () {
  return _nodesUi.nui.getHighestLevelNodesInList(canvas.getSelectedNodes()).filter(function (n) {
    return !n.link();
  }).length > 1;
};
this.showMakeWaypoint = function () {
  return canvas.getSelectedNodes().length > 0 && !canvas.isViewOnly();
};
this.showLinkToSelection = function () {
  return canvas.getSelectedNodes().length >= 1;
};
this.showExport = function () {
  return canvas.getSelectedNodes().length > 0;
};

this.showRegionOptions = function () {
  return _toolbarUi.tui.isRegionTarget() && !canvas.getSelectedNodes().length && !canvas.getSelectedLinks().length;
};

this.showEditRegionTitle = function () {
  return _toolbarUi.tui.isRegionTarget() && !_toolbarUi.tui.isMultiRegionTarget() && !canvas.getSelectedNodes().length && !canvas.getSelectedLinks().length;
};

this.showCommentOption = function () {
  if (!canvas.isFeatureEnabled('comments')) return false;
  return canvas.getSelectedNodes().length || canvas.getSelectedLinks().length;
};
/* conditions for different tool arrangements */

/* only one card selected */
this.isCardTarget = function () {
  return _toolbarUi.tui.isCardTarget();
};

/* only two cards selected */
this.isTwoCardTarget = function () {
  return _toolbarUi.tui.isTwoCardTarget();
};

/* only one top level card with parts selected */
this.isSystemTarget = function () {
  return _toolbarUi.tui.isSystemTarget();
};

/* parts or R cards selected */
this.isAttachedCardTarget = function () {
  return _toolbarUi.tui.isAttachedCardTarget();
};

/* only relationships selected */
this.isRelationshipTarget = function () {
  return _toolbarUi.tui.isRelationshipTarget();
};

/* multiple cards and 1 or more relationships */
this.isMixedSelectionTarget = function () {
  return _toolbarUi.tui.isMixedSelectionTarget();
};

this.setActiveTool = function (element) {
  _this.clearActiveTools();
  element.classList.add('active');
};

this.unsetActiveTool = function (element) {
  element.classList.remove('active');
};

this.getToolbarTargetClass = function () {
  return _toolbarUi.tui.getToolbarTargetClass();
};

this.showToolbar = function () {
  if (canvas.isViewOnly()) return false;
  return true;
};

canvas.operation.on('disconnected', function () {
  _this.root.classList.add('disabled');
});

canvas.operation.on('reconnected', function () {
  _this.root.classList.remove('disabled');
});

this.handleMouseEnter = function () {
  _this.mouseEntered = true;
};

this.handleMouseLeave = function () {
  _this.mouseEntered = false;
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('bulk-actions-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/bulk-actions-menu.html
// module id = 591
// module chunks = 0